/**
 * Converte qualquer valor de data (string YYYY-MM-DD, ISO com T/horas, ou objeto Date)
 * para a string formatada em padrão brasileiro (DD/MM/AAAA) sem sofrer deslocamento de fuso horário.
 */
export function formatDateBR(value) {
    if (!value) return "-";

    if (typeof value === "string") {
        const cleanStr = value.split("T")[0].split(" ")[0];
        const parts = cleanStr.split("-");
        if (parts.length === 3) {
            const [year, month, day] = parts;
            if (year.length === 4) {
                return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
            }
        }
    }

    try {
        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) return String(value);

        // Compensa o timezone para evitar recuo de dia em fusos negativos (ex: UTC-3 Brasil)
        const userTimezoneOffset = date.getTimezoneOffset() * 60000;
        const adjustedDate = new Date(date.getTime() + userTimezoneOffset);
        return adjustedDate.toLocaleDateString("pt-BR");
    } catch (e) {
        return String(value);
    }
}

/**
 * Converte data para o formato YYYY-MM-DD adequado para inputs do tipo "date"
 * ou para envio no payload de APIs.
 */
export function formatToDateInput(value) {
    if (!value) return "";

    if (typeof value === "string") {
        const cleanStr = value.split("T")[0].split(" ")[0];
        const parts = cleanStr.split("-");
        if (parts.length === 3 && parts[0].length === 4) {
            return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
        }
    }

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
